import CouponsPage from './CouponsPage';

export default { CouponsPage };
